export default __webpack_public_path__ + "adf3646978af2654f1c3960f3e12ca6d.woff";